// @ts-ignore
export const ISPROD = process.env.NODE_ENV !== 'development';
export default ISPROD;

export const twoSentences = (value: string) => {
  return value.split('.').slice(0, 2).join('.') + '.';
};

export const oneSentence = (value: string | undefined) => {
  if (!value) return '';
  return value.split('.').slice(0, 1).join('.') + '.';
};

export const sleep = (ms: number) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};
